/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Offline_Desc7Inputs */

const en_svc_mobile_app_development_offline_desc7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Works on a train, in a tunnel, or on airplane mode, local persistence with graceful sync when connectivity returns.`)
};

const ar_svc_mobile_app_development_offline_desc7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يعمل في القطار أو النفق أو وضع الطائرة, حفظ محلي مع مزامنة سلسة عند عودة الاتصال.`)
};

const bn_svc_mobile_app_development_offline_desc7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ট্রেনে, টানেলে বা এয়ারপ্লেন মোডেও কাজ করে, লোকাল পার্সিস্টেন্স এবং কানেক্টিভিটি ফিরলে সুন্দর সিঙ্ক।`)
};

const de_svc_mobile_app_development_offline_desc7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktioniert im Zug, im Tunnel oder im Flugzeugmodus, lokale Persistenz mit reibungsloser Synchronisierung bei wiederhergestellter Verbindung.`)
};

const es_svc_mobile_app_development_offline_desc7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciona en un tren, en un túnel o en modo avión, persistencia local con sincronización elegante cuando regresa la conectividad.`)
};

const fr_svc_mobile_app_development_offline_desc7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctionne dans un train, dans un tunnel ou en mode avion, persistance locale avec synchronisation gracieuse au retour de la connectivité.`)
};

const pt_svc_mobile_app_development_offline_desc7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciona em trem, túnel ou modo avião, persistência local com sincronização elegante quando a conectividade retorna.`)
};

const zh_svc_mobile_app_development_offline_desc7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`火车上、隧道里、飞行模式下都能用，恢复连接后平滑同步，本地数据不丢。`)
};

const tr_svc_mobile_app_development_offline_desc7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trende, tünelde ya da uçak modunda çalışır, bağlantı dönünce sorunsuz senkronla yerel kalıcılık.`)
};

const ru_svc_mobile_app_development_offline_desc7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Работает в поезде, туннеле или авиарежиме, локальное хранение с мягкой синхронизацией при возврате связи.`)
};

const pl_svc_mobile_app_development_offline_desc7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Działa w pociągu, tunelu lub w trybie samolotowym, lokalna trwałość z płynną synchronizacją po przywróceniu łączności.`)
};

/**
* | output |
* | --- |
* | "Works on a train, in a tunnel, or on airplane mode, local persistence with graceful sync when connectivity returns." |
*
* @param {Svc_Mobile_App_Development_Offline_Desc7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_offline_desc7 = /** @type {((inputs?: Svc_Mobile_App_Development_Offline_Desc7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Offline_Desc7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_offline_desc7(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_offline_desc7(inputs)
	if (locale === "de") return de_svc_mobile_app_development_offline_desc7(inputs)
	if (locale === "es") return es_svc_mobile_app_development_offline_desc7(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_offline_desc7(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_offline_desc7(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_offline_desc7(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_offline_desc7(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_offline_desc7(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_offline_desc7(inputs)
	return en_svc_mobile_app_development_offline_desc7(inputs)
});
export { svc_mobile_app_development_offline_desc7 as "svc_mobile-app-development_OFFLINE_desc" }